import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { nanoid } from 'nanoid';
import DateTH from '../../../Helper/date-th';
import Carousel from "react-bootstrap/Carousel";
import { updateParcelsRemarkMultiple } from '../../../Service/service.Parcels';
import swal from 'sweetalert';

function ModalRemarkMulti({ barcodes, setModalRemarkMulti,showModalRemarkMulti, onFinish}) {
    const [remark,setRemark] = useState("");

    const updateBarCodeRemarMultiplek = async () => {
        try {
          const result = await updateParcelsRemarkMultiple(barcodes, remark);
          swal({
            title: "ความสำเร็จ !",
            text: "",
            icon: "success",
            showConfirmButton: true,
            button: "ปิด",
            timer: 750,
          });
          onFinish();
        } catch (e) {
          console.log('exception = ', e.message);
          swal({
            title: "เกิดข้อผิดพลาด !",
            text: "",
            icon: "warning",
            showConfirmButton: true,
            button: "ปิด",
            timer: 1500,
          })
        }
      };

    return (
        <>
        <Modal
            show={showModalRemarkMulti}
            onHide={() => {
                setModalRemarkMulti(false);
                setRemark("");
                onFinish()
            }}
            size="lg"
        >
            <Modal.Header closeButton>
            <Modal.Title>เพิ่มหมายเหตุหลายพัสดุฯ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <center>
                    <div>
                        <textarea style={{ width: "100%",}}
                        value={remark}
                        name={"remark"}
                        onChange={(e) => {
                            setRemark(e.target.value);
                        }} />
                        <div align="right">
                          <button
                            type="button"
                            className={
                              "btn btn btn-primary ml-1"
                            }
                            onClick={(e) => {
                                updateBarCodeRemarMultiplek(remark);
                            }}
                          >
                            บันทึก
                          </button>
                        </div>
                    </div>
                </center>
                {/* {failImgData.length === 0 ? <div style={{ color: 'red', textAlign: 'center', padding: '50px' }}>ไม่พบข้อมูล</div> : ''} */}
            </Modal.Body>
        </Modal>
        </>
    );
}

export default ModalRemarkMulti;
